#import ../Assets/ApartmentCardAsset.graphql
#import "~/graphql/fragments/BookingInfo.graphql"

fragment ApartmentsListItem on apartment_Entry {
    uri

    property: parent {
        uri
        ... BookingInfo
    }

    ... on apartment_Entry {
        title
        description: cardDescription
        roomId: mewsId
        mewsVoucherCodeDesktop
        mewsVoucherCodeMobile
        image: cardImage {
            id
            url
            alt
            title
            width
            height
            ... ApartmentCardAsset
        }
    }

    amenitiesBlock {
        
            ... on amenitiesBlockBlock_Entry {
                amenities {
                    ... on amenity_Entry {
                        shorthand
                        title
                    }
                }
            }
        
    }
}
